import changelogData from '../ChangelogData';

const fuseReactLatestVersion = changelogData?.[0]?.version;

export default fuseReactLatestVersion;
